module.exports = __webpack_public_path__ + "img/output_11.5b425445.png";